import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Plus } from "lucide-react";

type CreateForm = {
  name: string;
  address: string;
  phone: string;
  ownerEmail: string;
  plan: string;
  amount: string;
  billingCycle: string;
};

interface NurseryCreateDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  form: CreateForm;
  onFormChange: (form: CreateForm) => void;
  onCreate: () => void;
  isPending: boolean;
}

const NurseryCreateDialog = ({ open, onOpenChange, form, onFormChange, onCreate, isPending }: NurseryCreateDialogProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogTrigger asChild>
        <Button className="gap-1.5">
          <Plus className="w-4 h-4" />
          إنشاء حضانة
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-lg" dir="rtl">
        <DialogHeader>
          <DialogTitle>إنشاء حضانة جديدة</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div>
            <Label>اسم الحضانة *</Label>
            <Input value={form.name} onChange={(e) => onFormChange({ ...form, name: e.target.value })} placeholder="مثال: حضانة النور" />
          </div>
          <div>
            <Label>البريد الإلكتروني للمالك *</Label>
            <Input type="email" value={form.ownerEmail} onChange={(e) => onFormChange({ ...form, ownerEmail: e.target.value })} placeholder="owner@example.com" dir="ltr" />
            <p className="text-xs text-muted-foreground mt-1">يجب أن يكون المالك مسجلاً في المنصة مسبقاً</p>
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div>
              <Label>العنوان</Label>
              <Input value={form.address} onChange={(e) => onFormChange({ ...form, address: e.target.value })} />
            </div>
            <div>
              <Label>الهاتف</Label>
              <Input value={form.phone} onChange={(e) => onFormChange({ ...form, phone: e.target.value })} dir="ltr" />
            </div>
          </div>
          <div className="border-t pt-4 space-y-3">
            <p className="font-medium text-sm">خطة الاشتراك</p>
            <div className="grid grid-cols-3 gap-3">
              <div>
                <Label>الخطة</Label>
                <Select value={form.plan} onValueChange={(v) => onFormChange({ ...form, plan: v })}>
                  <SelectTrigger><SelectValue /></SelectTrigger>
                  <SelectContent>
                    <SelectItem value="basic">أساسي (إداري)</SelectItem>
                    <SelectItem value="standard">قياسي (إداري + تعليمي)</SelectItem>
                    <SelectItem value="premium">مميز (كامل)</SelectItem>
                  </SelectContent>
                </Select>
              </div>
              <div>
                <Label>المبلغ (ج.م)</Label>
                <Input type="number" value={form.amount} onChange={(e) => onFormChange({ ...form, amount: e.target.value })} dir="ltr" />
              </div>
              <div>
                <Label>الدورة</Label>
                <Select value={form.billingCycle} onValueChange={(v) => onFormChange({ ...form, billingCycle: v })}>
                  <SelectTrigger><SelectValue /></SelectTrigger>
                  <SelectContent>
                    <SelectItem value="monthly">شهري</SelectItem>
                    <SelectItem value="yearly">سنوي</SelectItem>
                  </SelectContent>
                </Select>
              </div>
            </div>
          </div>
          <Button onClick={onCreate} disabled={isPending} className="w-full">
            {isPending ? "جاري الإنشاء..." : "إنشاء الحضانة"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default NurseryCreateDialog;
